import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={12} height={12} viewBox="0 0 12 12" className="paymentRequestIcon" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props} style={{transform: "scale(1.01)", strokeWidth: "0.65"}}>
    <path
      d="M9.685 1.588h-7.37c-1.023 0-1.852.829-1.852 1.852V8.42c0 1.023.829 1.852 1.852 1.852h7.37c1.023 0 1.852-.829 1.852-1.852V3.44c0-1.023-.83-1.852-1.852-1.852Z"
      fill={props.fill || 'white'}
      strokeLinejoin="round"
      stroke={props.stroke || '#B3B3B3'}
    />
    <path
        strokeLinecap="round"
        d="M6.482 4.91h2.862M6.482 7.09H8.21m-4.564.557c.546 0 .988-.369.988-.823 0-.455-.442-.824-.988-.824s-.989-.369-.989-.824c0-.454.443-.823.989-.823m0 3.294c-.546 0-.989-.369-.989-.823m.989.823v.33m0-3.624v-.33m0 .33c.546 0 .988.369.988.823"
      />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const PaymentRequest = memo(ForwardRef);
export default PaymentRequest;
